import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// 🌐 API Base URL (adjust if different)
const API_URL = 'http://localhost:8000/api/v1/blog';

// ✅ Thunk to fetch all blogs
export const fetchBlogs = createAsyncThunk('blog/fetchBlogs', async (_, thunkAPI) => {
  try {
    const response = await axios.get(API_URL);
    return response.data; // expected: array of blog objects
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch blogs');
  }
});

// ✅ Thunk to add a new blog
export const addBlog = createAsyncThunk('blog/addBlog', async (formData, thunkAPI) => {
  try {
    const response = await axios.post(API_URL, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data; // newly added blog
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to add blog');
  }
});

const blogSlice = createSlice({
  name: 'blog',
  initialState: {
    blogs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 📥 Fetch Blogs
      .addCase(fetchBlogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogs.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs = action.payload;
      })
      .addCase(fetchBlogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ➕ Add Blog
      .addCase(addBlog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addBlog.fulfilled, (state, action) => {
        state.loading = false;
        state.blogs.unshift(action.payload); // add new blog to top
      })
      .addCase(addBlog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default blogSlice.reducer;
